// extracted by mini-css-extract-plugin
export default {"root":"AddNewEnterpriseModal_root__teZqO","placeHolderShimmer":"AddNewEnterpriseModal_placeHolderShimmer__4y7Bn"};